import type { SourceRef } from "@cafe/shared";
import { Info } from "lucide-react";

/** "Fuente": the exact endpoint + params behind each figure, so every number can be verified. */
export function SourceList({ sources, notes, period }: { sources: SourceRef[]; notes?: string[]; period?: { from: string; to: string } }) {
  return (
    <details className="mt-2 text-[11px] text-roast/80">
      <summary className="flex cursor-pointer list-none items-center gap-1 select-none hover:text-espresso">
        <Info className="size-3" /> Fuente {period ? `· ${period.from} a ${period.to}` : ""}
      </summary>
      <div className="mt-1 space-y-1 rounded-lg bg-crema p-2">
        {sources.map((s, i) => (
          <p key={i} className="break-all">
            <span className="font-medium">{s.description}:</span>{" "}
            <code className="font-mono">
              {s.endpoint}
              {s.params && Object.keys(s.params).length ? `?${new URLSearchParams(s.params).toString()}` : ""}
            </code>
          </p>
        ))}
        {notes?.map((n) => (
          <p key={n}>• {n}</p>
        ))}
      </div>
    </details>
  );
}
